import { apiClient } from './apiClient';
import { authService } from './authService';

const getCompanyParam = () => {
  const companyId = authService.getCompanyId();
  return companyId ? `companyId=${companyId}` : '';
};

export const pmScheduleService = {
  // Get all PM schedules
  async getSchedules() {
    return apiClient.get(`/api/cmms/pm-schedules?${getCompanyParam()}`);
  },

  // Get PM schedules by status
  async getSchedulesByStatus(status) {
    return apiClient.get(`/api/cmms/pm-schedules/status/${status}?${getCompanyParam()}`);
  },

  // Get PM schedules by type (INTERNAL/EXTERNAL)
  async getSchedulesByType(type) {
    return apiClient.get(`/api/cmms/pm-schedules/type/${type}?${getCompanyParam()}`);
  },

  // Get PM schedules for an asset
  async getSchedulesByAsset(assetId) {
    return apiClient.get(`/api/cmms/pm-schedules/asset/${assetId}?${getCompanyParam()}`);
  },

  // Get upcoming PM schedules
  async getUpcomingSchedules(days = 7) {
    return apiClient.get(`/api/cmms/pm-schedules/upcoming?${getCompanyParam()}&days=${days}`);
  },

  // Get overdue PM schedules
  async getOverdueSchedules() {
    return apiClient.get(`/api/cmms/pm-schedules/overdue?${getCompanyParam()}`);
  },

  // Get single PM schedule by ID
  async getScheduleById(id) {
    return apiClient.get(`/api/cmms/pm-schedules/${id}?${getCompanyParam()}`);
  },

  // Get PM schedule history
  async getScheduleHistory(id) {
    return apiClient.get(`/api/cmms/pm-schedules/${id}/history?${getCompanyParam()}`);
  },

  // Create new PM schedule
  async createSchedule(data) {
    return apiClient.post(`/api/cmms/pm-schedules?${getCompanyParam()}`, data);
  },

  // Update PM schedule
  async updateSchedule(id, data) {
    return apiClient.put(`/api/cmms/pm-schedules/${id}?${getCompanyParam()}`, data);
  },

  // Update PM schedule status (pause/activate)
  async updateScheduleStatus(id, status) {
    return apiClient.put(`/api/cmms/pm-schedules/${id}/status?${getCompanyParam()}&status=${status}`);
  },

  // Manually trigger PM generation for a single schedule
  async triggerGeneration(id) {
    return apiClient.post(`/api/cmms/pm-schedules/${id}/generate?${getCompanyParam()}`);
  },

  // Process all due PM schedules (manually trigger the scheduler)
  async processDueSchedules() {
    return apiClient.post(`/api/cmms/pm-schedules/process-due`);
  },

  // Get all due PM schedules (for debugging)
  async getDueSchedules() {
    return apiClient.get(`/api/cmms/pm-schedules/due?${getCompanyParam()}`);
  },

  // Delete PM schedule
  async deleteSchedule(id) {
    return apiClient.delete(`/api/cmms/pm-schedules/${id}?${getCompanyParam()}`);
  },
};
